<template lang="pug">
    .form-group
        legend {{ value.name }}
        div(:class="{ 'row' : inline }")
          div(:class="{ 'col' : inline }")
            .form-check(:class="{ 'disabled' : inline }" v-for="item, key in value.options" :key="key")
              input(type="radio" :id="'question-' + index + '-option-' + key" :name="'question-'+index" :value="item.score" @click="next(key)" :class="{'checked': checked(key)}")
              label(:for="'question-' + index + '-option-' + key") {{ item.option }}
</template>

<script>
export default {
  props: ["value", "index", "inline"],
  methods: {
    next(option) {
      if (this.inline) {
        return;
      }
      this.value.select = parseInt(option);
      this.$emit("next", this.index + 1);
    },
    checked(key) {
      return this.value.select === key;
    }
  }
};
</script>